import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import Icon from "../../components/interface/Icon";
import interfaceIdentifiers from "../../constants/interfaceIdentifiers";

class TableRowGutterView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this._domNode = null;
    this.onMouseDown = this.onMouseDown.bind(this);
  }

  // Focus on GutterView temporarily when clicking, so that TableView itself retains focus
  onMouseDown() {
    this._domNode.focus();
  }

  render() {
    return (
      <div
        ref={node => (this._domNode = node)}
        tabIndex={0}
        onMouseDown={this.onMouseDown}
        id={this.props.id}
        className={`tableRowGutter ${this.props.selected ? "selected" : ""}`}
        onClick={this.props.onClick}
        onDoubleClick={this.props.onDoubleClick}
        title={this.props.tooltip}
      >
        {this.props.icon ? (
          <Icon
            icon={this.props.icon}
            color={this.props.iconColor}
            pulse={this.props.pulsateIconId === interfaceIdentifiers.TABLE_VIEW_DRAG_HANDLE}
          />
        ) : null}
      </div>
    );
  }
}

TableRowGutterView.propTypes = {
  // Cell Data
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  selected: PropTypes.bool,
  id: PropTypes.string,
  tooltip: PropTypes.string,
  pulsateIconId: PropTypes.string
};

export default TableRowGutterView;
